module.exports = __webpack_public_path__ + "img/catFoodLogo_2024.c7799237.png";